"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import $ from "jquery";
import App from "./accounts_payable/app";
import Account from "./api/account";
import Auth from "./util/auth";
import ResetPasswordPage from "./accounts_payable/reset_password/reset_password_page";
import ConfirmAndSubmitPage from "./accounts_payable/confirm_and_submit_page";
import DocumentIndexerPage from "./accounts_payable/document_indexer_page";
import FlowModeFindNextItemPage from "./accounts_payable/flow_mode/flow_mode_find_next_item_page";
import EmailPage from "./accounts_payable/email_page";
import FactorInvoiceExtractDataPage from "./accounts_payable/factor_invoice_extract_data_page";
import Hotkeys from "./util/hotkeys";
import LoginForm from "./accounts_payable/login_form";
import Logout from "./accounts_payable/logout";
import presenceService from "./accounts_payable/presence_service_next_gen";
import ReplyView from "./accounts_payable/reply_view";
import AnalyticsPage from "./accounts_payable/analytics_page";
import RootPage from "./accounts_payable/root_page";
import history, { locationDescriptor } from "./accounts_payable/app_history";
import { Router, Route, IndexRoute, Redirect } from "react-router";
import { Provider } from "react-redux";
import configureStore from "./accounts_payable/redux/configure_store";
import PineRoute from "./util/pine/pine_route";
import React from "react";
import ErrorBoundary from "./components/error_boundary";
import { readOnlyRedirect } from "./accounts_payable/read_only";
import { carrierInvoiceWorkflowRedirect } from "./accounts_payable/carrier_invoice_workflow";
import { factorInvoiceWorkflowWithEmail } from "./accounts_payable/flow_mode/dashboard_paths";
global.__DEV__ = process.env.NODE_ENV === "development";
if (__DEV__) {
  window.React = React;
}
$.ajaxSetup({
  beforeSend: function(jqXHR, settings) {
    jqXHR.url = settings.url;
    jqXHR.data = settings.data;
  }
});
const ElmRoute = PineRoute;
window.$hubtranHistory = history;
function requireAuth(nextState, replace) {
  var _a, _b, _c;
  const redirect = (path2, state = null) => replace(locationDescriptor(path2, null, state));
  let path;
  let oldLogin = false;
  if (nextState.location.pathname === "/" && nextState.location.hash.length > 1) {
    path = nextState.location.hash + nextState.location.search;
    if (path.substr(0, 7) === "#/login") {
      oldLogin = true;
    }
  } else {
    path = nextState.location.pathname + nextState.location.search;
  }
  path = path.replace(/^\/?#/, "");
  if (!Auth.isAuthenticated() && (path.substr(0, 6) !== "/login" || oldLogin)) {
    const next = oldLogin ? null : path;
    redirect("/login", { nextPathname: next });
    return;
  }
  if (isLogout(path)) {
    notifyPresenceServiceOfNavigation(path, nextState);
    return;
  }
  if (needsTermsAgreement(path) && path.substr(0, 6) !== "/terms") {
    redirect("/terms", { nextPathname: path });
    return;
  }
  if (path === "/terms") {
    notifyPresenceServiceOfNavigation(path, nextState);
    return;
  }
  if (customerRepOnly()) {
    redirect("/customer_representative", { nextPathname: path });
    return;
  }
  if (insightsOnly()) {
    redirect("/insights_dashboard", { nextPathname: path });
    return;
  }
  if (readOnlyFactorInvoices()) {
    const readOnlyRedirectPath = readOnlyRedirect(path);
    if (readOnlyRedirectPath) {
      redirect(readOnlyRedirectPath, { nextPathname: path });
    }
    return;
  }
  if (Account.useFactorInvoiceWorkflowPage() && !((_a = nextState.location.query) == null ? void 0 : _a.forceReact)) {
    const match = path.match(/\/factor_invoices\/(\d+)/);
    if (match) {
      const target = factorInvoiceWorkflowWithEmail(
        Number(match[1]),
        (_b = nextState.location.query) == null ? void 0 : _b.emailId,
        (_c = nextState.location.query) == null ? void 0 : _c.onDone
      );
      redirect(target.toString());
      return;
    }
  }
  if (Account.useCarrierInvoiceWorkflowPage()) {
    const carrierInvoiceWorkflowPath = carrierInvoiceWorkflowRedirect(path);
    if (carrierInvoiceWorkflowPath) {
      redirect(carrierInvoiceWorkflowPath);
      return;
    }
  }
  notifyPresenceServiceOfNavigation(path, nextState);
}
function readOnlyFactorInvoices() {
  const user = Auth._currentUser;
  return !!(user == null ? void 0 : user.read_only_factor_invoices);
}
function notifyPresenceServiceOfNavigation(path, nextState) {
  const searchParams = new URLSearchParams(nextState.location.search);
  searchParams.delete("onDone");
  const searchString = searchParams.toString();
  const pathName = nextState.location.pathname;
  presenceService.startIfNeeded(Auth._currentUser);
  presenceService.userMovedTo(
    "/app" + maybeShortenedPath(pathName) + (searchString ? "?" + searchString : "")
  );
}
function maybeShortenedPath(pathName) {
  const urlRegex = /^(\/index-document-batches\/\d+)\/factor_invoices\/\d+/i;
  const match = pathName.match(urlRegex);
  if (match) {
    return match[1];
  } else {
    return pathName;
  }
}
function needsTermsAgreement(path) {
  return !Auth._currentUser.terms_agreed_to_at;
}
function isLogout(path) {
  return path.substr(0, 7) === "/logout";
}
function customerRepOnly() {
  return Auth._currentUser && Auth._currentUser.accessible_apps.includes("customer_representative") && !Auth._currentUser.accessible_apps.includes("payables") && !Auth._currentUser.accessible_apps.includes("receivables");
}
function insightsOnly() {
  return Auth._currentUser && Auth._currentUser.accessible_apps.includes("insights_dashboard") && !Auth._currentUser.accessible_apps.includes("payables") && !Auth._currentUser.accessible_apps.includes("receivables");
}
const store = configureStore();
function NewRoot() {
  if (window.location.pathname == "/users/password/edit") {
    return /* @__PURE__ */ jsx(ResetPasswordPage, {});
  } else {
    const user = Auth.getCurrentUser();
    const settingsPath = user && user.account.forwarder_account ? "/settings/contacts" : "/settings/account";
    return /* @__PURE__ */ jsx(Provider, { store, "data-component": "NewRoot", children: /* @__PURE__ */ jsx(Router, { history, children: /* @__PURE__ */ jsxs(Route, { path: "/", component: App, children: [
      /* @__PURE__ */ jsx(IndexRoute, { component: RootPage, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(Route, { path: "okta_login", component: ElmRoute }),
      /* @__PURE__ */ jsx(Route, { path: "help", component: ElmRoute, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(Route, { path: "activity", component: ElmRoute, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "billing_requirements",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "documents_viewer",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "email_search",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(Route, { path: "elm*", component: ElmRoute, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "dashboard*",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "to_be_scraped_loads",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "index-document-batches/:batchId",
          component: DocumentIndexerPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "flow",
          component: FlowModeFindNextItemPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "carrier_invoices_workflow/:carrierInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "factor_invoices_workflow/:factorInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "factor_invoices_workflow/batch/:batchId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "factor_invoices/:factorInvoiceId",
          component: FactorInvoiceExtractDataPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "readonly_factor_invoices/:factorInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "readonly_document_batches/:documentBatchId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "readonly_emails/:emailId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "index-document-batches/:batchId/factor_invoices/:factorInvoiceId",
          component: FactorInvoiceExtractDataPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(Route, { path: "login", component: LoginForm }),
      /* @__PURE__ */ jsx(Route, { path: "forwarding-has-moved", component: ElmRoute }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "document_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "document_batch_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "document_group_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ),
      /* @__PURE__ */ jsx(Route, { path: "logout", component: Logout, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "index-document-batches/:batchId/loads/:loadId/carrier_invoices/:carrierInvoiceId",
          component: ConfirmAndSubmitPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "loads/:loadId(/carrier_invoices/:carrierInvoiceId)",
          component: ConfirmAndSubmitPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(Redirect, { from: "settings", to: settingsPath }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/carriers",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/carriers/:carrierId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/carriers/:id/documents",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/account",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/client_portal",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/contacts",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/customers(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/debtors(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/document_types",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/exceptions",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/integrations",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/next_gen_audit",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/rules",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/reference_fields",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/reports",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/users(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/users/:id/enable",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/verifications",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/scraper_status",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "settings/pod_definition",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "forwarding/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "client_submission/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "verification_batch/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "index-document-batches/:documentBatchId/loads/:loadStateId/confirm",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "email/:id",
          component: EmailPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "email_merge",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "reply/:id",
          component: ReplyView,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(Route, { path: "terms", component: ElmRoute, onEnter: requireAuth }),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "customer_representative",
          component: () => {
            window.location.href = "/customer_representative";
            return null;
          }
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "insights_dashboard",
          component: () => {
            window.location.href = "/insights_dashboard";
            return null;
          }
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "loads/:loadId/carrier_invoices/:carrierInvoiceId/ltl-reconcile",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "held_submissions",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "debtor_changes",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "debtor_changes/templates/:id",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "my_clients_demo",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "noa_management",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "noa_management/sent",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "noa_management/skipped",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(
        Route,
        {
          path: "analytics",
          component: AnalyticsPage,
          onEnter: requireAuth
        }
      ),
      /* @__PURE__ */ jsx(Redirect, { from: "*", to: "/" })
    ] }) }) });
  }
}
const AP = {
  bootstrap: function() {
    Hotkeys.listenForKeys(
      {
        zoomIn: ["numplus", "alt+="],
        zoomOut: ["numminus", "alt+-"],
        rotateLeft: ["left"],
        rotateRight: ["right"],
        nextPage: ["alt+p", "pagedown"],
        prevPage: ["alt+shift+p", "pageup"],
        nextGroup: "alt+g",
        prevGroup: "alt+shift+g",
        togglePOD: ["alt+d", "numpad0", "alt+shift+d"],
        markIllegible: ["alt+t"],
        toggleHidden: ["alt+h"],
        changeDoctype: ["numstar", "alt+e"],
        hotkeyMenu: ["ctrl+/"]
      },
      this
    );
    if (window.location.pathname == "/passwords/expired_token" || window.location.pathname.startsWith("/driver_app/links/"))
      return;
    ReactDOM.render(
      /* @__PURE__ */ jsx(ErrorBoundary, { name: "accounts-payable", children: /* @__PURE__ */ jsx(NewRoot, {}) }),
      document.getElementById("react-container")
    );
  }
};
window.AccountsPayable = AP;
$(document).ready(function() {
  AP.bootstrap();
});
export default AP;
